import "@awtoban/ui/styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root mount node in index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
